import { useNavigate } from 'react-router-dom';

import { Button } from 'src/components';
import logo from 'src/assets/icons/team_cap_icon.svg';
import CircleIcon from 'src/assets/images/404-icon.svg';

const NoFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center items-center h-screen text-center">
      <div className="flex items-center gap-4">
        <img src={logo} alt="teamcap" className="h-14 w-[74px] mt-3" />
        <div className="text-blue-950 text-[62px] font-normal font-Gilroy">
          TeamCap
        </div>
      </div>
      <div className="flex items-center gap-5 mt-4">
        <p className="text-blue-950 text-[160px] font-normal font-Gilroy">4</p>
        <img src={CircleIcon} alt="404" className="w-[200px] h-[200px]" />
        <p className="text-blue-950 text-[160px] font-normal font-Gilroy">4</p>
      </div>
      <div className="text-center text-blue-950 text-[40px] font-semibold font-SFProDisplay leading-[45px] mt-4">
        Oops, we can’t find that page...
      </div>
      <div className="text-center text-slate-500 text-base font-semibold font-SFProDisplay leading-[19px] mt-[10px]">
        Either something went wrong or the page doesn’t exist anymore...
      </div>
      <Button
        variant="normal"
        size="sm"
        label="Go To Home"
        className="block min-w-[132px] h-12 mt-8"
        type="button"
        onClick={() => navigate(-1)}
      />
    </div>
  );
};

export default NoFoundPage;
